import { BreadcrumbItem } from "./sharedBreadcrumbUtils";
import { generateCurrentPath } from "@helpers/urlHelper";

/**
 * Generate JSON-LD structured data for breadcrumbs (client-safe version)
 */
export const generateBreadcrumbStructuredData = (
  breadcrumbs: BreadcrumbItem[]
): string => {
  if (!breadcrumbs || breadcrumbs.length === 0) {
    return "";
  }

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": breadcrumbs.map((item, index) => ({
      "@type": "ListItem",
      "position": index + 1,
      "name": item.name,
      "item": generateCurrentPath(item.href)
    }))
  };
  return JSON.stringify(structuredData);
};
